import { EnvironmentInjector, Injector } from '@angular/core';

export const injectorRef: {
  injector: Injector | undefined;
  environmentInjector: EnvironmentInjector | undefined;
} = {
  injector: undefined,
  environmentInjector: undefined,
};
